<template>
	<NoticeListPage page-type="quantity" />
</template>

<script setup>
import NoticeListPage from '@/components/notice/NoticeListPage.vue';
</script>
